var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "c-ir-contact-us-page" },
    [
      _c(
        "Container",
        [
          _c(
            "Row",
            { staticClass: "c-ir-contact-us-page__top" },
            [
              _c(
                "Column",
                [
                  _c(
                    "Heading",
                    {
                      directives: [
                        {
                          name: "epi-edit",
                          rawName: "v-epi-edit",
                          value: "Label",
                          expression: "'Label'",
                        },
                      ],
                      attrs: { isCategory: "" },
                    },
                    [_vm._v(_vm._s(_vm.model.label))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Column",
                { attrs: { md: 10 } },
                [
                  _c(
                    "Heading",
                    {
                      directives: [
                        {
                          name: "epi-edit",
                          rawName: "v-epi-edit",
                          value: "Title",
                          expression: "'Title'",
                        },
                      ],
                      attrs: { level: 3, noMarginTop: "" },
                    },
                    [_vm._v(_vm._s(_vm.model.title))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            { staticClass: "c-ir-contact-us-page__info" },
            [
              _c(
                "Column",
                { attrs: { md: 10 } },
                [
                  _c("XhtmlField", {
                    directives: [
                      {
                        name: "epi-edit",
                        rawName: "v-epi-edit",
                        value: "ContactInfo",
                        expression: "'ContactInfo'",
                      },
                    ],
                    attrs: { items: _vm.model.contactInfo },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.notEmptyObject(
            _vm.model.formBlock && _vm.model.formBlock.content
          ) || _vm.isEditable
            ? _c(
                "FormBlock",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "epi-edit",
                        rawName: "v-epi-edit",
                        value: "Form",
                        expression: "'Form'",
                      },
                    ],
                    staticClass:
                      "c-ir-contact-us-page__form o-bg o-bg--beige-light",
                    attrs: { id: "form" },
                  },
                  "FormBlock",
                  _vm.model.formBlock.content,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }